/** Build body for PUT /api/v1/companies/:id (UpdateCompanyDto). */
export function buildCompanyUpdatePayload(
  company: Record<string, unknown>,
): Record<string, unknown> {
  const payload: Record<string, unknown> = {
    name: company.name,
    type: company.type,
    address: company.address,
    websiteUrl: company.websiteUrl,
    phone: company.phone,
    fax: company.fax,
    contactPerson: company.contactPerson,
    contactPersonEmail: company.contactPersonEmail,
    country: company.country,
    modifiedBy: company.modifiedBy,
  };

  if (typeof company.bookingSubdomain === "string") {
    payload.bookingSubdomain = company.bookingSubdomain.trim().toLowerCase();
  }

  const globalSetting = company.globalSetting as Record<string, unknown> | undefined;
  if (globalSetting) {
    const gs: Record<string, unknown> = {};
    if (globalSetting.dueDate != null) {
      gs.dueDate = globalSetting.dueDate;
    }
    if (globalSetting.gymStartingDate != null) {
      gs.gymStartingDate = globalSetting.gymStartingDate;
    }
    if (globalSetting.whatsappApiKey != null) {
      gs.whatsappApiKey = globalSetting.whatsappApiKey;
    }
    const sms = globalSetting.sms as Record<string, unknown> | undefined;
    if (sms) {
      gs.sms = {
        username: sms.username,
        password: sms.password,
        sender: sms.sender,
      };
    }
    if (Object.keys(gs).length > 0) {
      payload.globalSetting = gs;
    }
  }

  return payload;
}
